var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.dataField && _vm.layoutID)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.$t(("i18nLayout." + _vm.layoutID))[("" + (_vm.data.dataField))]))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }